'use strict';
const ActionImportAPI = require('balus/infra/api/action/import');

module.exports = class Service {
    constructor(action, contentVersion) {
        this._action = action;
        this._contentVersion = contentVersion;
    }

    import() {
        return (new ActionImportAPI())
            .import(this._action.key, this._contentVersion.key);
    }
};



// WEBPACK FOOTER //
// ./balus/app/service/action/import.js